import React, { useState } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Paper } from '@mui/material';

const classes = {
    imageContainer: {
        textAlign: 'center',
    },
    image: {
        width: "150px",
        height: 'auto',
    },
}


const images = [
{
    id: 1,
    url: '/sample.png', // Replace with the actual image URL
  },
  {
    id: 2,
    url: '/sample.png', // Replace with the actual image URL
  },
  {
    id: 3,
    url: '/sample.png', // Replace with the actual image URL
  },
]


const PatternSelector = ({selectedPattern, setSelectedPattern}) => {
    const handleImageChange = (event) => {
        setSelectedPattern(event.target.value);
    };
    return (
        <Stack>
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="images"
                    name="imageSelection"
                    value={selectedPattern}
                    onChange={handleImageChange}
                >
                    {images.map((image) => (
                        <FormControlLabel
                            key={image.id}
                            value={image.id.toString()}
                            control={<Radio />}
                            label={
                            <Paper elevation={3} sx={classes.imageContainer}>
                                <img
                                src={image.url}
                                alt={`Image ${image.id}`}
                                style={classes.image}
                                />
                            </Paper>
                        }
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Stack>
    );
}

export default PatternSelector;
